import { useMutation } from 'react-query';
import {PartnerApi} from "../../api/partner.api";
import {useLoansStore} from "../../store/loans.store";

export const useLoanVendorProductAvailability = (productId) => {
    const setLoanVendorProductAvailability = useLoansStore((state) => state.setLoanVendorProductAvailability);

    return useMutation(PartnerApi.loanVendorProductAvailability, {
        onSuccess: (data) => {
            setLoanVendorProductAvailability(data);
        },
        onError: (error) => {
            console.error('Login failed:', error);
        },
    });
};